import { Notification } from 'store/notifications/types';
import { useSelector } from 'react-redux';
import { notifications } from 'store/notifications/selectors';

export const useNotifications = (): Notification[] => useSelector(notifications);
